// @flow

import type {Node, StatelessFunctionalComponent} from 'react';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  children: Node,
};

export const Base: StatelessFunctionalComponent<Props> = styled.div(
  ({theme}) => css`
    ${theme.typography.paragraphMedium};
    position: relative;
  `
);
